/**
 * @generated SignedSource<<74cf38ff0068bb17a51ddbe929509452>>
 * @relayHash b6b21d741f7d9136c7763578df01dabe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0074a4b3881a7369629a977cc9c6649ac3180bd5eded8eb69dc031bf6cfe7ca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a0074a4b3881a7369629a977cc9c6649ac3180bd5eded8eb69dc031bf6cfe7ca",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
